import authService from "./authService";

const LEGACY_API_BASE_URL = "http://localhost:8000/api";

const normalizeUrl = (url) => {
  if (typeof url !== "string") {
    return url;
  }

  return url.replace(LEGACY_API_BASE_URL, authService.getApiBaseUrl());
};

export const apiFetch = (url, options) => {
  const hasAuthHeader = !!options?.headers?.Authorization;
  const defaultHeaders = hasAuthHeader ? {} : authService.getAuthHeaders();

  return fetch(normalizeUrl(url), {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options?.headers || {}),
    },
  });
};

export default apiFetch;
